import { render, staticRenderFns } from "./DownloadCandidateProfileButton.vue?vue&type=template&id=5b2bfef6&"
import script from "./DownloadCandidateProfileButton.vue?vue&type=script&lang=js&"
export * from "./DownloadCandidateProfileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports